module.exports = __webpack_public_path__ + "img/21-r.b41cff88.png";